<div class="padding-md wrap">
  <div class="content">
    <div class="header">{{ "@pages.accessControl.header" | translate }}</div>
    <div class="qr-code border-md">
      <img
        *ngIf="accessControlData$ | async as accessControlData"
        [src]="accessControlData.qr_code"
        alt="access code"
      />
      <div
        class="app-spinner-container"
        *ngIf="(accessControlData$ | async) === null"
      >
        <ion-spinner class="app-spinner"></ion-spinner>
      </div>
    </div>
    <div class="info">
      <span
        class="line"
        *ngFor="
          let line of '@pages.accessControl.info' | translate | splitLines
        "
        >{{ line }}</span
      >
    </div>
  </div>
</div>
